/**
 * 模块名称: 招聘模块 -> 招聘申请
 * @author zhuyan@372163.com
 */

import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Form,
  Input,
  InputNumber,
  Select,
  message,
  DatePicker,
  // Radio,
  // Upload,
  // Icon,
  // Button,
  // Row,
  // Col,
} from 'antd'
import BtnGroup from '@/components/BtnGroup'
// import { uploadDragger } from '@/utils/uploadDragger'
import moment from 'moment'

const FormItem = Form.Item
const Option = Select.Option
// const { Dragger } = Upload

const jobType = [
  { id: 1, name: '销售'},
  { id: 2, name: '运营'},
  { id: 3, name: '职能'},
  { id: 4, name: '直播'}
]

// let draggerObj = {}

const Addrecruit = (props) => {
  const { getFieldDecorator, validateFields, setFieldsValue } = props.form
  const { seteditVisible, getList, setformLoading, editId } = props
  const [saveLoading, setSaveLoading] = useState(false)
  const [selectData, setSelectData] = useState({
    emergency: [], //紧急程度
    reason: [], //增补原因
    sexVal: [], //性别
    marriage: [], //婚姻状况
    education: [], //学历
  })
  const [postSalaryEnd, setPostSalaryEnd] = useState('')
  const [reasonType, setReasonType] = useState('')
  // const [jobIntroType, setJobIntroType] = useState(1)
  
  useEffect(() => {
    getSelectData()
    // draggerObj = uploadDragger({
    //   accept: '.rar, .zip, .doc, .docx, .pdf, .jpg',
    //   limitNum: 1,
    //   limitSize: 5,
    // })
  }, [])

  useEffect(() => {
    // 编辑反显
    if (editId && selectData.reason.length > 0) {
      api.getStaffRecruitmentInfo({ id: editId }).then(res => {
        let treatment = []
        if (res.treatment) {
          treatment = res.treatment.split('~')
          setPostSalaryEnd(treatment[1])
        }
        setFieldsValue({
          name: res.name,
          applyRecruitNum: res.applyRecruitNum,
          treatment: res.treatment ? treatment[0] : '',
          expYear: res.expYear,
          jobType: res.jobType,
          recruitReason: res.recruitReason,
          arrivalDate: res.arrivalDate ? moment(res.arrivalDate) : null,
          jobRequirements: res.jobRequirements ? res.jobRequirements : '',
          age: res.age ? res.age : '',
          educationLevel: res.educationLevel ? res.educationLevel : '',
          major: res.major ? res.major : '',
          elseRequirements: res.elseRequirements ? res.elseRequirements : '',
          jobReq: res.jobReq ? res.jobReq : ''
        })
      })
    }
  }, [selectData])

  const getSelectData = () => {
    setformLoading(true)
    return Promise.all([
      api.getCommon({ type: 'recruit_reason' }),
      // api.getCommon({ type: 'sex' }),
      // api.getCommon({ type: 'staff_marriage_status' }),
      api.getCommon({ type: 'staff_education_level' }),
    ]).then(list => {
      setformLoading(false)
      setSelectData({
        reason: list[0],
        education: list[1],
      })
      return list
    }).catch(() => setformLoading(false))
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  // 保存招聘
  const formSubmit = (e) => {
    e.preventDefault()
    validateFields((err, vals) => {
      if (!err) {
        if (editId) {
          vals.id = editId
        }
        setSaveLoading(true)
        api.saveStaffRecruitmentInfo({
          id: vals.id,
          leaveStaffName: vals.leaveStaffName,
          leaveDate: vals.leaveDate ? moment(vals.leaveDate).format('YYYY-MM-DD') : '',
          jobType: vals.jobType,
          jobReq: vals.jobReq,
          name: vals.name,
          applyRecruitNum: vals.applyRecruitNum,
          treatment: vals.treatment ?  vals.treatment + '~' + postSalaryEnd : '',
          expYear: vals.expYear,
          recruitReason: vals.recruitReason,
          arrivalDate: vals.arrivalDate ? moment(vals.arrivalDate).format('YYYY-MM-DD') : '',
          jobRequirements: vals.jobRequirements,
          age: vals.age,
          educationLevel: vals.educationLevel,
          major: vals.major,
          elseRequirements: vals.elseRequirements
        })
          .then(() => {
            setSaveLoading(false)
            seteditVisible(false)
            message.success('添加成功')
            getList()
          })
          .catch(() => setSaveLoading(false))
      }
    })
  }

  //岗位薪资后面部分
  const onPostSalary = (e) => {
    // console.log(e.target.value)
    setPostSalaryEnd(e.target.value.trim())
  }

  //选中增补原因
  const onSelectReason = key => {
    setReasonType(key)
    // switch (key) {
    //   case 1:
    //     setFieldsValue({
    //       jobintrotype: 2
    //     })
    //     setJobIntroType(2)
    //     break
    //   case 6:
    //   case 5:
    //     setFieldsValue({
    //       jobintrotype: 1
    //     })
    //     setJobIntroType(1)
    //     break
    // }
  }

  //日期限制
  const disabledDate = (current) => {
    // console.log('current', current)
    return current && current < moment().subtract(1, "day")
  }

  // const onPreview = () => {}

  return (
    <div>
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <FormItem label="增补原因">
          {getFieldDecorator('recruitReason', {
            rules: [{ required: true, message: '请选择增补原因' }]
          })(
            <Select placeholder="请选择" onSelect={onSelectReason}>
              {selectData.reason.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
            </Select>
          )}
        </FormItem>
        {
          reasonType === 5 && (
            <>
              <FormItem label="替补人员">
                {getFieldDecorator('leaveStaffName', {
                  rules: [{ required: true, message: '请输入替补人员' }]
                })(
                  <Input placeholder="请输入" />
                )}
              </FormItem>
              <FormItem label="替补人员离职日期">
                {getFieldDecorator('leaveDate', {
                  rules: [{ required: true, message: '请选择替补人员离职日期' }]
                })(
                  <DatePicker placeholder="请选择替补人员离职日期" style={{ width: '100%'}}/>
                )}
              </FormItem>
            </>
          ) 
        }
        {/* <FormItem label="岗位说明书" required>
          {getFieldDecorator('jobintrotype', {
            initialValue: 1, 
          })(<Radio.Group 
              onChange={evt => setJobIntroType(evt.target.value)} 
              disabled={[1, 6].includes(reasonType)}
            >
            <Radio value={1}>选择已有岗位说明书</Radio>
            <Radio value={2}>上传新增岗位说明书</Radio>
          </Radio.Group>)}
        </FormItem>
        {jobIntroType === 1 ? (
          <FormItem wrapperCol={{ span: 18, offset: 6 }}>
            <Row gutter={8}>
              <Col span={16}>
                {getFieldDecorator('jopintroselect', {
                  rules: [{ required: true, message: '请选择岗位说明书' }]
                })(
                  <Select 
                    placeholder="请选择岗位说明书"
                    showSearch
                    filterOption={(input, option) => option.props.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                  >
                    {jobType.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
                  </Select>
                )}
              </Col>
              <Col span={8}>
                <Button type="primary" onClick={onPreview}>岗位说明书预览</Button>
              </Col>
            </Row>
          </FormItem>
        ) : (
          <>
            <Form.Item wrapperCol={{ span: 18, offset: 6 }}>
              {getFieldDecorator('jobintrofile', {
                valuePropName: 'fileList',
                getValueFromEvent: draggerObj.normFile,
                rules: [{ required: true, message: '请上传岗位说明书' }]
              })(
                <Dragger {...draggerObj}>
                  <p className="ant-upload-drag-icon">
                    <Icon type="inbox" />
                  </p>
                  <p className="ant-upload-text">点击或将文件拖拽到这里上传</p>
                  <p className="ant-upload-hint">
                    支持扩展名：.rar, .zip, .doc, .docx, .pdf, .jpg
                  </p>
                </Dragger>
              )}
            </Form.Item>
            <FormItem label="岗位说明书名称">
              {getFieldDecorator('jobintroname', {
                rules: [{ required: true, message: '请输入岗位说明书名称' }]
              })(
                <Input placeholder="请输入岗位说明书名称" />
              )}
            </FormItem>
          </>
        )} */}
        <FormItem label="岗位名称">
          {getFieldDecorator('name', {
            rules: [{ required: true, message: '请输入岗位名称' }]
          })(
            <Input placeholder="请输入岗位名称" />
          )}
        </FormItem>
        <FormItem label="岗位类别">
          {getFieldDecorator('jobType', {
            rules: [{ required: true, message: '请选择岗位类别' }]
          })(
            <Select placeholder="请选择">
              {jobType.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
            </Select>
          )}
        </FormItem>
        {/* <FormItem label="职级">
          {getFieldDecorator('joblevel', {
            rules: [{ required: true, message: '请选择职级' }]
          })(
            <Select placeholder="请选择">
              {jobType.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
            </Select>
          )}
        </FormItem>
        <FormItem label="入职项目">
          {getFieldDecorator('joblevel', {
            rules: [{ required: true, message: '请选择入职项目' }]
          })(
            <Select placeholder="请选择">
              {jobType.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
            </Select>
          )}
        </FormItem> */}
        <FormItem label="招聘人数">
          {getFieldDecorator('applyRecruitNum', {
            rules: [{ required: true, message: '请输入招聘人数' }]
          })(
            <InputNumber min={1} placeholder="请输入招聘人数" style={{ width: '100%'}}/>
          )}
        </FormItem>
        <FormItem label="岗位薪资">
          {getFieldDecorator('treatment')(
            <Input placeholder="请输入" style={{ width: 179 }}/>
          )}
          <span style={{ marginLeft: '15px', marginRight: '15px' }}>~</span>
          <Input placeholder="请输入" style={{ width: 180 }} onChange={onPostSalary} value={postSalaryEnd}/>
        </FormItem>
        <FormItem label="工作经验">
          {getFieldDecorator('expYear', {
            rules: [{ required: true, message: '请输入' }]
          })(
            <Input placeholder="请输入" />
          )}
        </FormItem>
        <FormItem label="希望到岗日期">
          {getFieldDecorator('arrivalDate')(
            <DatePicker placeholder="请选择希望到岗日期" disabledDate={disabledDate} style={{ width: '100%'}}/>
          )}
        </FormItem>
        <FormItem label="年龄">
          {getFieldDecorator('age')(
            <Input placeholder="请输入年龄" />
          )}
        </FormItem>
        <FormItem label="学历">
          {getFieldDecorator('educationLevel')(
            <Select placeholder="请选择学历">
              {selectData.education.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
            </Select>
          )}
        </FormItem>
        <FormItem label="专业">
          {getFieldDecorator('major')(
            <Input placeholder="请输入专业" />
          )}
        </FormItem>
        <FormItem label="岗位职责">
          {getFieldDecorator('jobRequirements')(
            <Input.TextArea placeholder="请输入岗位职责" />
          )}
        </FormItem>
        <FormItem label="任职资格">
          {getFieldDecorator('jobReq')(
            <Input.TextArea placeholder="请输入任职资格" />
          )}
        </FormItem>
        <BtnGroup onCancel={() => seteditVisible(false)} loading={saveLoading} />
      </Form>
    </div>
  );
}

export default Form.create()(Addrecruit)

